import React from 'react';
import { ABOUT_PAGE } from '../mock';
import Reveal from './Reveal';

const Passion = () => {
  const { passion } = ABOUT_PAGE;
  return (
    <section className="bg-ink">
      <div className="grid lg:grid-cols-2">
        {/* Photo */}
        <div className="relative min-h-[50vh] overflow-hidden lg:min-h-0">
          <img
            src={passion.image}
            alt="Kanwal singing on stage"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 ease-out hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
        </div>

        {/* Text */}
        <div className="flex items-center px-6 py-14 md:px-14 md:py-20 xl:px-24">
          <div>
            <Reveal>
              <p className="mb-6 text-[10px] uppercase tracking-[0.45em] text-gold">
                {passion.label}
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif text-3xl font-light leading-[1.15] tracking-[0.03em] text-white md:text-4xl xl:text-[2.9rem]">
                {passion.titleLines.map((line, i) => (
                  <React.Fragment key={line}>
                    {line}
                    {i < passion.titleLines.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h2>
            </Reveal>
            <Reveal delay={220}>
              <div className="mt-6 h-px w-12 bg-gold" />
            </Reveal>
            <Reveal delay={300}>
              <div className="mt-8 max-w-md space-y-5">
                {passion.paragraphs.map((p) => (
                  <p key={p} className="text-base leading-relaxed text-neutral-300">
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Passion;
